import { MailCodeOfferType } from '../enums/MailCodeOfferType';
import { MailCodeOfferField } from '../types/MailCodeOfferField';

export const mailCodeRequiredOfferFields: Record<
  MailCodeOfferType,
  MailCodeOfferField[]
> = {
  [MailCodeOfferType.RATE]: ['newPayment', 'newRate', 'newTerm'],
  [MailCodeOfferType.SAVINGS]: [
    'currentPayment',
    'newPayment',
    'potentialSavings',
  ],
};
